/* Fond de carte.
   CARTO exige désormais une clé : sans elle, ses tuiles répondent 200 mais
   estampillées « API KEY REQUIRED ». Tant que REACT_APP_CARTO_KEY est vide
   (clé gratuite, 5 M de tuiles/mois, sur carto.com/basemaps/apikey), on sert
   les tuiles OpenStreetMap standard : sans clé, et leur politique d'usage
   admet un back-office à faible trafic. La variable est lue à la compilation :
   la renseigner dans Coolify demande un redéploiement. */
const CARTO_KEY = process.env.REACT_APP_CARTO_KEY;

const CARTO_VOYAGER = 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png';
const OSM_STANDARD = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';

export const BASEMAP_URL = CARTO_KEY ? `${CARTO_VOYAGER}?key=${CARTO_KEY}` : OSM_STANDARD;

const OSM_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';

/* L'attribution doit rester visible : c'est une condition d'utilisation des
   deux fournisseurs, pas une décoration. */
export const BASEMAP_ATTRIBUTION = CARTO_KEY
  ? `${OSM_ATTRIBUTION} &copy; <a href="https://carto.com/attributions">CARTO</a>`
  : OSM_ATTRIBUTION;
